import { useEffect } from 'react';
import { useGtmPage } from 'modules/gtm/modules/sections/page/hooks';
import { gtmPushInternalSearch } from 'modules/gtm/modules/sections/search/search';
import { useSiteConfig } from 'modules/shop/siteConfig/hooks';

export const useInitGTM = () => {
  useGtmPage();
};

export const useGtmInternalSearch = (totalProducts = 0) => {
  const { gtmData, triggerSuggestionEvent } = useSiteConfig();

  useEffect(() => {
    if (gtmData?.isSuggestionEvent && gtmData?.fss) {
      gtmPushInternalSearch(
        gtmData?.fss,
        totalProducts,
        gtmData?.isSuggestionEvent,
      );
      triggerSuggestionEvent?.(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
